import JSZip from 'jszip';

export const zipMeshFile = async (file) => {
  const buffer = await file.arrayBuffer();
  const header = new Uint8Array(buffer, 0, 2);
  // Skip zipping if already a ZIP
  if (header[0] === 0x50 && header[1] === 0x4b) return file;

  const zip = new JSZip();
  zip.file(file.name, buffer);
  const blob = await zip.generateAsync({ type: 'blob' });
  return new File([blob], file.name.replace(/\.[^.]+$/, '.zip'), { type: 'application/zip' });
};
